
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.8 17.6H2.2A2.2 2.2 0 010 15.4V2.2A2.2 2.2 0 012.2 0h17.6A2.2 2.2 0 0122 2.2v13.2a2.2 2.2 0 01-2.2 2.2zM2.2 2.2v13.2h17.6V2.2H2.2zm7.425 10.284a.825.825 0 01-.825-.824V5.94a.825.825 0 011.287-.682l4.279 2.86a.814.814 0 010 1.364l-4.279 2.86a.824.824 0 01-.462.142z"}})])
          )
        }
      }
    